import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("BusinessParties/api/DocumentSettingsQuery").then((r) => {
        commit("setList", r.data.data);
        return r.data.data;
      });
    },
    create({ commit, dispatch }, model) {
      return ajax
        .post("BusinessParties/api/DocumentSettings", model)
        .then(() => {});
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "BusinessParties/api/DocumentSettings",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    update({ commit, dispatch }, model) {
      return ajax
        .put("BusinessParties/api/DocumentSettings", model)
        .then(() => {});
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
  },
};
